export function logError(...error) {
    console.error('[FRONTEND CRITICAL ERROR]', ...error);
}
export function logWarning(...warning) {
    console.warn('[FRONTEND WARNING]', ...warning);
}
export function logInfo(message) {
    console.log('[FRONTEND INFO]', message);
}
